module.exports = __webpack_public_path__ + "img/app_korat_3.8b82cc47.jpg";